<template>
  <div id="view-mcq">
    <br />
    <h4 align="center" :class="{  'h5': $vuetify.breakpoint.mdAndDown, 'h4': $vuetify.breakpoint.lgAndUp, }">
      {{ $route.params.name != null ? $route.params.name : this.name }} - Multiple Choice Questions
    </h4>
    <br />
    <v-container>
      <v-expansion-panels class="dark">
        <v-expansion-panel v-for="i in filteredQues" :key="i.quesid" class="mx-0 my-1 pa-0 py-0">
          <v-expansion-panel-header class="my-0 py-0 mx-0" style="outline: none;">
            <v-card flat>
              <v-card-title
                :class="{  'caption': $vuetify.breakpoint.smAndDown,  'subtitle-2': $vuetify.breakpoint.mdAndUp,  }"
              >Q{{i.quesno}}. {{i.ques}}</v-card-title>
              <v-card-actions v-if="i.quesimg != undefined" class="mx-5 my-0 py-0">
                <v-row>
                  <img v-bind:src="i.quesimg" class="img-fluid" alt="Responsive image" />
                </v-row>
              </v-card-actions>
              <v-card-text
                :class="{  'caption': $vuetify.breakpoint.smAndDown,  'subtitle-2': $vuetify.breakpoint.mdAndUp,  }"
              >
                (a) {{i.op1}}
                <br />
                (b) {{i.op2}}
                <br />
                (c) {{i.op3}}
                <br />

                (d) {{i.ans}}
              </v-card-text>
            </v-card>
          </v-expansion-panel-header>

          <v-expansion-panel-content
            class="mx-5"
            :class="{  'caption': $vuetify.breakpoint.smAndDown,  'subtitle-2': $vuetify.breakpoint.mdAndUp,  }"
          >
            Answer:
            <nl2br tag="p" :text="i.ans" />
            <v-row v-if="i.expimg != undefined" class="mx-1">
              <img v-bind:src="i.expimg" class="img-fluid" alt="Responsive image" align="left" />
            </v-row>Explanation:
            <nl2br tag="p" :text="i.explaination" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="text-center">
        <br />
        <br />
        <v-pagination v-model="page" :length="Math.round(this.count/10) < this.count/10 ? (this.count/10)+1 : Math.round(this.count/10)"></v-pagination>
      </div>
    </v-container>
    <br />
    <br />
  </div>
</template>


<script>
import db from "@/fb";

export default {
  name: "dashboard",
  data() {
    return {
      quesans: [],
      count: 0,
      name: "",
      page: 1,
      newpage: this.page,
    };
  },
  computed: {
    filteredQues() {
      return this.quesans.slice(this.page * 10 - 10, this.page * 10);
    },
  },

  created() {
    var id = this.$route.params.id;
    var name = this.$route.params.name;
    //console.log(id);

    if (name == null) {
      //console.log('Null hai');
      let ref = db.collection("Subjects").doc(id);
      ref.get().then((snapshot) => {
        if (snapshot.exists) {
          var post = snapshot.data();
          this.name = post["Name"];
        } else {
          console.log("No such document!");
        }
      });
    }

    db.collection("Subjects")
      .doc(id)
      .collection("McQ")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            quesno: (this.count += 1),
            ques: doc.data().ques,
            ans: doc.data().ans,
            op1: doc.data().op1,
            op2: doc.data().op2,
            op3: doc.data().op3,
            explaination: doc.data().explaination,
            quesimg: doc.data().quesimage,
            expimg: doc.data().expimage,
          };
          this.quesans.push(data);
        });
      });
  },
  methods: {
    Del(quesid) {
      var id = this.$route.params.id;
      console.log("Delete Clicked - " + quesid);
      console.log("Delete Sub Id - " + id);

      if (confirm("Are you sure?")) {
        db.collection("Subjects")
          .doc(id)
          .collection("McQ")
          .doc(quesid)
          .delete()
          .then(() => {
            this.refresh();
          });
      }
    },
    Edit() {
      console.log("Edit McQ Clicked");
    },
    refresh() {
      var id = this.$route.params.id;
      this.quesans = [];
      this.count = 0;

      db.collection("Subjects")
        .doc(id)
        .collection("McQ")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              quesno: (this.count += 1),
              ques: doc.data().ques,
              ans: doc.data().ans,
              op1: doc.data().op1,
              op2: doc.data().op2,
              op3: doc.data().op3,
              explaination: doc.data().explaination,
              quesimg: doc.data().quesimage,
              expimg: doc.data().expimage,
            };
            this.quesans.push(data);
          });
        });
    },
  },
};
</script>